/* The significance labels of lambda/stats_charts.py, for the results tables:
   the same thresholds on the ADJUSTED p, so a table and its chart agree. */
const THRESHOLDS = [[0.0001, '****'], [0.001, '***'], [0.01, '**'], [0.05, '*']];

export function significanceLabel(p) {
  if (p === null || p === undefined || Number.isNaN(p)) return 'ns';
  const hit = THRESHOLDS.find(([limit]) => p < limit);
  return hit ? hit[1] : 'ns';
}

/* Numbers as the results table shows them: 4 significant digits, and very
   small p-values in scientific notation rather than as 0.0000. */
export function fmt(value) {
  if (value === null || value === undefined) return '—';
  if (typeof value === 'boolean') return value ? '✓' : '✗';
  if (value !== 0 && Math.abs(value) < 0.0001) return value.toExponential(2);
  return Number(value.toPrecision(4)).toString();
}

/* The full factorial of the factors' levels: one arm per combination. */
export function fullFactorial(factors) {
  return factors.reduce((arms, f) => arms.flatMap((arm) => f.levels.map((lv) => ({
    key: [arm.key, lv.key].filter(Boolean).join('_'),
    label: [arm.label, lv.label].filter(Boolean).join(' / '),
    levels: { ...arm.levels, [f.key]: lv.key },
  }))), [{ key: '', label: '', levels: {} }]);
}
